// extracted by mini-css-extract-plugin
export default {"tile_container":"S5","tile_img_container":"T5","not_recommended_label":"U5","modal_root":"V5","content":"W5","warning":"X5","x_mark":"Y5","tile_img":"Z5","tile_type":"a6","tile_product_title":"b6","tile_product_price":"c6","tile_descr_line":"e6","tile_descr_icon":"f6","info_icon":"g6","tile_descr_text":"h6","tile_btns_container":"i6","info_container":"j6","info_text":"k6"};
    if(module.hot) {
      // 1714422958160
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  